export default "__VITE_ASSET__958e4c77__"